<template>
  <div class="container">
    <div class="monitor">
      <div class="monitor_title">
        <div class="monitor_logo">
          <img src="../../assets/images/实时监测.png" alt="" />
          <img src="../../assets/images/历史监测.png" alt="" />
        </div>
        <div class="monitor_query">
          <el-select @change="typeChange" placeholder="请选择类型" filterable v-model="type">
            <el-option v-for="(item, index) in typeItem" :label="item.name" :value="item.value"></el-option>
          </el-select>
          <el-date-picker v-model="timeRange.startTime" :type="dateType" :value-format="valueFormat" placeholder="选择开始时间" :picker-options="startDateLimit" @focus="changeStart"> </el-date-picker>
          <el-date-picker v-model="timeRange.endTime" :type="dateType" :value-format="valueFormat" placeholder="选择结束时间" :picker-options="endDateLimit" @focus="changeEnd"> </el-date-picker>
        </div>
        <div class="monitor_dictionary">
          <div @click="queryHander(1)" class="query query_btns">开始查询</div>
          <div @click="queryHander(2)" class="print query_btns">生成报表</div>
          <div @click="queryHander(3)" class="realTimeData query_btns">
            数据分析
          </div>
          <div @click="queryHander(4)" class="dictionary query_btns">
            分析依据
          </div>
        </div>
      </div>
      <div class="monitor_content">
        <div @click="btnChange(1)" v-if="needBtn" class="monitor_prev">
          <img src="@/assets/images/shensuo.png" />
        </div>
        <div @click="btnChange(2)" v-if="needBtn" class="monitor_next">
          <img src="@/assets/images/shensuo.png" />
        </div>
        <div class="monitor_left">
          <el-form :model="form">
            <el-select popper-class="monitor_left_select" @change="changeHander" v-model="form.name" placeholder="请选择监测站点">
              <el-option v-for="(item, index) in stationItem" :key="index" :label="item.name" :value="item.stcd"></el-option>
            </el-select>
          </el-form>
          <div class="monitor_box">
            <vue-scroll>
              <div v-if="item.haveData" v-for="(item, index) in realTimeItem" :key="index" class="monitor_real" :class="item.type">
                <p class="real_title">
                  <span>{{ item.name }}</span>
                  <span>{{ item.time }}</span>
                </p>
                <div class="real_content">
                  <div v-for="(item, index) in item.data" :key="index" class="real_box">
                    <div :title="
                        item.name +
                          ' ' +
                          (item.value - 0).toFixed(2) +
                          item.unit
                      " :style="{ color: item.color1, borderColor: item.color4 }" :class="item.code">
                      <span>{{ item.name }}</span>
                      <span :style="{
                          color: item.color1,
                          backgroundColor: item.color2
                        }">{{
                          item.level ||
                            (item.value - 0).toFixed(2) + item.unit || 0.0}}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
        <div class="monitor_right">
          <div class="myChart_container" v-for="(item, index) in nowHistoryItem" :key="index">
            <span :style="{ color: item.color }">{{ item.name }} {{ item.unit }}</span>
            <div class="myChart_box"></div>
          </div>
        </div>
      </div>
    </div>
    <transition name="el-fade-in-linear">
      <div v-if="hide.needHide" class="hide">
        <div class="hide_container">
          <div v-if="hide.analysis" class="hide_box">
            <div class="hide_title">
              {{ hide.title }}
              <i @click="hide.needHide = false" title="关闭" class="el-icon-close"></i>
            </div>
            <div class="hide_content">
              <div class="hide_list">
                <vue-scroll>
                  <div class="list list_title">
                    <div v-for="(item, index) in hide.titleItem" :key="index">
                      {{ item }}
                    </div>
                  </div>
                  <div v-for="(item, index) in hide.listItem" :key="index" class="list">
                    <div :style="{ color: item.color }" :title="item.nameA">
                      {{ item.nameA }}
                    </div>
                    <div :style="{ color: item.color }" :title="item.nameB">
                      {{ item.nameB }}
                    </div>
                    <div :style="{ color: item.color }" :title="item.nameC">
                      {{ item.nameC }}
                    </div>
                    <div :style="{ color: item.color }" :title="item.nameD">
                      {{ item.nameD }}
                    </div>
                    <div :title="item.nameE">
                      <a v-if="item.Url" :href="item.Url" target="_Blank">{{
                        item.nameE
                      }}</a>
                      <span v-else>{{ item.nameE }}</span>
                    </div>
                  </div>
                </vue-scroll>
              </div>
            </div>
            <el-pagination hide-on-single-page="true" v-if="hide.needPage" @current-change="hidePageChange" background layout="prev, pager, next" :page-size="hide.limit" :total="hide.total"></el-pagination>
            <div class="tips">数据仅供参考</div>
          </div>
          <div v-if="hide.report" class="hide_box report_box">
            <!-- 穿梭框 -->
            <!-- <div class="transfer_container">
              <el-transfer target-order="push" :titles="transfer.title" v-model="transfer.valueItem" :data="transfer.data"></el-transfer>
            </div> -->

            <div>
              <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange" border>全选</el-checkbox>

              <div v-if="item.haveData" v-for="(item, index) in realTimeItem" :key="index" class="monitor_real" :class="item.type">
                <div class="dialogtitle">{{item.name}}</div>
                <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange" :checked='false'>
                  <el-checkbox v-for="index in item.data" :label="index.code" :key="index.code" border>{{index.name}}</el-checkbox>
                </el-checkbox-group>
              </div>

            </div>
            <div class="hide_btns">
              <button @click="downloadHander()" class="el-button el-button--primary el-button--medium">
                下载
              </button>
              <button @click="hide.needHide = false, checkAll=false, checkedCities=[]" class="el-button el-button--danger el-button--medium">
                关闭
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import $ from "jquery";
import {
  getToday,
  getMonday,
  getMonth,
  colorRgb
} from "../../../static/js/date";
export default {
  data () {
    return {
      // 时间禁用
      endDateLimit: {},
      startDateLimit: {},
      dateType: "datetime",
      valueFormat: "yyyy-MM-dd HH:mm:ss",
      stationItem: [],
      type: "hour",
      timeRange: {
        startTime: '',
        endTime: '',
      },
      typeItem: [
         {
          name: "所有",
          value: "time"
        },
        {
          name: "每小时平均值",
          value: "hour"
        },
        {
          name: "每日平均值",
          value: "day"
        },
        {
          name: "每月平均值",
          value: "month"
        },
      ],
      needBtn: false,
      nowPage: 1,
      maxPage: null,
      num: 9,
      times: {
        todayTime: getToday("s", 0),
        mondayTime: getMonday("s", 0),
        monthTime: getMonth("s", 0)
      },
      form: {
        name: "",
        stcd: ""
      },
      realTimeItem: [],
      allHistoryItem: [],
      nowHistoryItem: [],
      hide: {
        needHide: false,
        analysis: false,
        report: false,
        needPage: false,
        title: "",
        titleItem: [],
        nowPage: 1,
        limit: 10,
        total: null,
        listItem: []
      },
      // 全选状态
      checkAll: true,
      isIndeterminate: true,
      // 最后选择项
      checkedCities: [],
      transfer: {
        data: [],
        // 全部选项
        valueItem: [],
        title: ["可选栏", "已选栏"]
      }
    };
  },
  components: {},
  methods: {
    changeEnd () {
      let self = this
      this.endDateLimit = {
        disabledDate (date) {
          var startDate = self.timeRange.startTime;
          startDate = startDate.replace(new RegExp("-", "gm"), "/");
          var startDateM = (new Date(startDate)).getTime() - 1; //得到毫秒数
          if (date.getTime() < startDateM) {
            return true;
          }
          return false;
        }
      }
    },
    changeStart () {
      this.startDateLimit = {
        disabledDate (date) {
          let zero = new Date().setHours(0, 0, 0, 0);
          if (date.getTime() > zero) {
            return true;
          }
          return false;
        }
      }
    },
    // 获取实时监测数据
    getRealTimeData (stcd) {
      this.axios
        .get(
          this.$store.state.Url4 + "naturalFactors/findElementCurrentByStcd",
          {
            // 通过这种方式解决模糊匹配后台报空指针异常的问题
            params: {
              stcd: stcd
            }
          }
        )
        .then(data => {
          data = data.data.data;
          this.realTimeItem = [];
          this.transfer.data = [];
          this.transfer.valueItem = [];
          for (let i in data) {
            if (typeof data[i] === "object") {
              let name,
                haveData = false,
                time = "",
                newData = [];
              if (i === "soilList") {
                name = "土壤";
              } else if (i === "weatherList") {
                name = "气象";
              } else if (i === "airList") {
                name = "空气";
              } else if (i === "waterList") {
                name = "水温与水环境";
              }
              if (data[i] && data[i].length > 0) {
                haveData = true;
                for (let z in data[i]) {
                  if (data[i][z].code === "UPTIME") {
                    time = data[i][z].value.substring(0, 19);
                  } else {
                    this.transfer.data.push({
                      key: data[i][z].code,
                      label: data[i][z].name
                    });
                    this.transfer.valueItem.push(data[i][z].code);
                    if (data[i][z].unit === "无") {
                      data[i][z].unit = "";
                    }
                    if (!data[i][z].value) {
                      data[i][z].value = "0.00";
                    }
                    //										console.log(this.$store.state.monitorLeverColor)
                    data[i][z].color1 = "#228B22";
                    data[i][z].color2 = colorRgb("#228B22", 0.2);
                    data[i][z].color4 = colorRgb("#228B22", 0.4);
                    newData.push(data[i][z]);
                  }
                }
              }
              for (let i in this.$store.state.monitorDictionaries) {
                for (let z in newData) {
                  if (
                    newData[z].name ===
                    this.$store.state.monitorDictionaries[i].name
                  ) {
                    newData[z].color1 = this.$store.state.monitorDictionaries[
                      i
                    ].color;
                    newData[z].color2 = colorRgb(
                      this.$store.state.monitorDictionaries[i].color,
                      0.2
                    );
                    newData[z].color4 = colorRgb(
                      this.$store.state.monitorDictionaries[i].color,
                      0.4
                    );
                    break;
                  }
                }
              }
              this.realTimeItem.push({
                type: i,
                name: name,
                data: newData,
                haveData: haveData,
                time: time
              });
            }
          }
          this.nowPage = 1;
          this.getHistoryData(stcd);
        });
    },
    // 获取历史监测数据
    getHistoryData (stcd) {
      this.axios
        .get(this.$store.state.Url4 + "naturalFactors/findElementDataByTime", {
          // 通过这种方式解决模糊匹配后台报空指针异常的问题
          params: {
            stcd: stcd,
            startTime: this.timeRange.startTime ? this.timeRange.startTime : "",
            endTime: this.timeRange.endTime ? this.timeRange.endTime : "",
            timeType: this.type
          }
        })
        .then(res => {
          let data = res.data.data;
          this.allHistoryItem = [];
          this.nowHistoryItem = [];
          for (let i in data) {
            for (let z in data[i]) {
              data[i][z].color = "#228B22";
              if (data[i][z].unit === "无") {
                data[i][z].unit = "";
              }
              for (let x in this.$store.state.monitorDictionaries) {
                if (
                  this.$store.state.monitorDictionaries[x].name ===
                  data[i][z].name
                ) {
                  data[i][z].color = this.$store.state.monitorDictionaries[
                    x
                  ].color;
                  if (data[i][z].unit === "无") {
                    data[i][z].unit = "";
                  }
                }
              }
              this.allHistoryItem.push(data[i][z]);
            }
          }
          if (this.allHistoryItem.length === 0) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: "暂无数据",
              type: "warning"
            });
            this.needBtn = false;
            return;
          } else {
            if (this.allHistoryItem.length >= this.num) {
              this.needBtn = true;
              this.maxPage = Math.ceil(this.allHistoryItem.length / this.num);
            } else {
              this.needBtn = false;
              this.maxPage = null;
            }
            this.changeData();
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    // 左侧下拉框切换
    changeHander () {
      this.timeRange.startTime = this.times.todayTime
      this.timeRange.endTime = getToday("e", 0)
      this.getRealTimeData(this.form.name);
    },
    // 类型切换
    typeChange () {
      this.timeRange.startTime = this.times.todayTime
      this.timeRange.endTime = getToday("e", 0,"end")
      if (this.type === "hour") {
        this.dateType = "datetime";
        this.valueFormat = "yyyy-MM-dd HH:mm:ss";
      } else if (this.type === "day") {
       this.timeRange.startTime = getMonday("s", 0)
        this.dateType = "date";
        this.valueFormat = "yyyy-MM-dd HH:mm:ss";
      } else if (this.type === "month") {
       this.timeRange.startTime = getMonth("s", 0)
        this.dateType = "month";
        this.valueFormat = "yyyy-MM-dd HH:mm:ss";
      }
    },
    handleCheckAllChange (val) {
      this.checkedCities = val ? this.transfer.valueItem : [];
      console.log(this.checkedCities);
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange (value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.transfer.valueItem.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.transfer.valueItem.length;
    },
    // 按钮点击事件
    queryHander (type) {
      this.hide.analysis = false;
      this.hide.needPage = false;
      this.hide.report = false;
      let stcd;
      for (let i in this.stationItem) {
        if (
          this.form.name === this.stationItem[i].name ||
          this.form.name === this.stationItem[i].stcd
        ) {
          this.nowPage = 1;
          stcd = this.stationItem[i].stcd;
          break;
        }
      }
      if (type === 1) {
        if (this.timeRange.startTime > this.timeRange.endTime) {
          this.$message({
            message: "结束时间不能低于开始时间",
            type: "warning"
          });
          this.timeRange.endTime = getToday("e", 0)
          return ''
        }
        if (this.timeRange.startTime == null && this.timeRange.endTime == null) {
          this.timeRange.startTime = this.times.todayTime
          this.timeRange.endTime = getToday("e", 0)
        }
        this.nowTime = getToday("e", 0);
        this.getHistoryData(stcd);
      } else if (type === 2) {
        if (this.allHistoryItem.length === 0) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: "暂无数据",
            type: "warning"
          });
          return;
        }
        // 没有报表数据提示框
        if (this.transfer.valueItem.length === 0) {
          this.$message({
            message: "暂无报表数据",
            type: "warning"
          });
          return;
        }
        // 默认全选
        this.checkAll = true
        this.checkedCities = this.transfer.valueItem

        this.hide.needHide = true;
        this.hide.report = true;
      } else if (type === 3) {
        this.hide.needHide = true;
        this.hide.analysis = true;
        this.hide.needPage = false;
        this.hide.title = "数据分析";
        this.hide.titleItem = [
          "要素名称",
          "要素数值",
          "要素等级",
          "等级名称",
          "依据来源"
        ];
        this.hide.listItem = [];
        this.axios
          .get(this.$store.state.Url4 + "station/AnalysisElementGradeByStcd", {
            // 通过这种方式解决模糊匹配后台报空指针异常的问题
            params: {
              stcd: stcd
            }
          })
          .then(res => {
            let data = res.data.data;
            let flag = true;
            for (let i in data) {
              if (data[i].length) {
                for (let z in data[i]) {
                  //									console.log(this.$store.state.monitorLeverColor, data[i][z])
                  this.hide.listItem.push({
                    nameA: data[i][z].eleName,
                    nameB: data[i][z].eleValue,
                    nameC: data[i][z].eleGrade,
                    nameD: data[i][z].gradeName,
                    nameE: data[i][z].Basis,
                    color: "#000000",
                    Url: data[i][z].basicUrl
                  });
                }
                flag = false;
              }
            }
            if (flag) {
              this.$message({
                showClose: true,
                duration: 1000,
                message: "暂无分析数据",
                type: "warning"
              });
              return;
            }
          })
          .catch(function (err) {
            console.log(err);
          });
      } else if (type === 4) {
        this.hide.needHide = true;
        this.hide.analysis = true;
        this.hide.needPage = true;
        this.hide.title = "分析依据";
        this.hide.titleItem = [
          "要素名称",
          "要素等级",
          "等级名称",
          "等级范围",
          "依据来源"
        ];
        this.getAnalysisData();
      }
    },
    // 生成报表 下载
    downloadHander () {
      if (this.checkedCities.length) {
        let keyStr = "",
          stcd;
        this.checkedCities.forEach(item => {
          for (let i of this.transfer.data) {
            if (i.key === item) {
              keyStr += "" + item + ",";
              break;
            }
          }
        });
        keyStr = keyStr.substr(0, keyStr.length - 1);
        this.nowTime = getToday("e", 0);
        this.form.name - 0 > 0
          ? (stcd = this.form.name)
          : (stcd = this.form.stcd); // 先判断是否是数值类型再获取值
        this.axios
          .get(
            this.$store.state.Url4 +
            "stationData/exportStationDataByStationCode",
            {
              // 通过这种方式解决模糊匹配后台报空指针异常的问题
              params: {
                stationCode: stcd,
                startTime: this.timeRange.startTime,
                endTime: this.timeRange.endTime,
                eleCol: keyStr,
                timeType: this.type
              }
            }
          )
          .then(res => {
            res = res.data;
            if (res.success) {
              window.open(this.$store.state.Url4 + res.data);
            }
          })
          .catch(function (err) {
            console.log(err);
          });
        this.hide.needHide = false;
        this.checkAll = false;
        this.checkedCities = [];
      } else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: "请选择需要下载的指标",
          type: "warning"
        });
      }
    },
    // 获取分析依据数据
    getAnalysisData () {
      this.hide.listItem = [];
      this.axios
        .get(this.$store.state.Url4 + "grade/findGradeFilter", {
          // 通过这种方式解决模糊匹配后台报空指针异常的问题
          params: {
            soId: this.$store.state.Soid,
            start: this.hide.nowPage,
            limit: this.hide.limit
          }
        })
        .then(res => {
          let data = res.data;
          this.hide.total = data.total;
          if (this.hide.total === 0) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: "暂无分析依据数据",
              type: "warning"
            });
            return;
          }
          data = data.data;
          for (let i in data) {
            this.hide.listItem.push({
              nameA: data[i].elementname,
              nameB: data[i].gradelevel,
              nameC: data[i].gradeName,
              nameD: data[i].symbol + data[i].range,
              nameE: data[i].source,
              Url: data[i].sourceUrl
            });
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    // 分析依据切换页码
    hidePageChange (page) {
      this.hide.nowPage = page;
      this.getAnalysisData();
    },
    // 根据当前页切换数据
    changeData () {
      this.nowHistoryItem = [];
      for (
        let i = (this.nowPage - 1) * this.num;
        i < this.num * this.nowPage;
        i++
      ) {
        if (this.allHistoryItem[i]) {
          this.nowHistoryItem.push(this.allHistoryItem[i]);
        }
      }
      setTimeout(() => {
        this.drawLine();
      });
    },
    // 切换图表
    btnChange (type) {
      if (type === 1) {
        if (this.nowPage <= this.maxPage && this.nowPage != 1) {
          this.nowPage--;
          this.changeData();
        }
      } else if (type === 2) {
        if (this.nowPage !== this.maxPage) {
          this.nowPage++;
          this.changeData();
        }
      }
    },
    // 绘制图表
    drawLine () {
      // 基于准备好的dom，初始化echarts实例
      for (let i = 0; i < this.num; i++) {
        let color,
          threshold,
          timeItem = [];
        if (this.nowHistoryItem[i]) {
          this.nowHistoryItem[i].yz !== "notNumber"
            ? (threshold = this.nowHistoryItem[i].yz - 0)
            : (threshold = -1);
          this.nowHistoryItem[i].color
            ? (color = this.nowHistoryItem[i].color)
            : (color = "#1484f7");
          let newColor = colorRgb(color);
          this.nowHistoryItem[i].valueDataList.forEach(item => {
            let time;
            item.startTime.length > 19
              ? (time = item.startTime
                .replace(" ", "\n")
                .substr(0, item.startTime.length - 2))
              : (time = item.startTime);
            timeItem.push(time);
          });
          // 绘制图表
          this.$echarts
            .init(
              document.querySelectorAll(".myChart_container .myChart_box")[i]
            )
            .setOption({
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  lineStyle: {
                    color: newColor
                  }
                },
                formatter: datas => {
                  let unit, maxValue, minValue;
                  for (let z in this.nowHistoryItem) {
                    if (this.nowHistoryItem[z].name === datas[0].seriesName) {
                      unit = this.nowHistoryItem[z].unit;
                      maxValue = this.nowHistoryItem[z].maxValue || 0.0;
                      minValue = this.nowHistoryItem[z].minValue || 0.0;
                      break;
                    }
                  }
                  let res = "";
                  let str = datas[0].axisValue.replace("\n", " ");
                  res =
                    str +
                    "<br/>" +
                    datas[0].marker +
                    datas[0].seriesName +
                    " " +
                    (datas[0].value - 0).toFixed(2) +
                    " " +
                    unit;
                  res +=
                    "<br/>" +
                    datas[0].marker +
                    "最大值 " +
                    (maxValue - 0).toFixed(2) +
                    " " +
                    unit;
                  res +=
                    "<br/>" +
                    datas[0].marker +
                    "最小值 " +
                    (minValue - 0).toFixed(2) +
                    " " +
                    unit;
                  return res;
                }
              },
              grid: {
                left: "20",
                right: "4%",
                bottom: "3%",
                top: "45",
                containLabel: true
              },
              xAxis: [
                {
                  type: "category",
                  boundaryGap: false,
                  axisLine: {
                    lineStyle: {
                      color: newColor
                    }
                  },
                  data: timeItem
                }
              ],
              dataZoom: [
                {
                  type: "inside",
                  start: 0,
                  end: 100
                },
                {
                  start: 0,
                  end: 10,
                  handleIcon:
                    "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
                  bottom: "40",
                  height: 8,
                  handleColor: newColor,
                  handleStyle: {
                    borderColor: newColor,
                    borderWidth: "1",
                    shadowBlur: 0,
                    background: newColor,
                    shadowColor: newColor
                  }
                }
              ],
              yAxis: [
                {
                  type: "value",
                  name: "",
                  axisTick: {
                    show: false
                  },
                  axisLine: {
                    lineStyle: {
                      color: newColor
                    }
                  },
                  axisLabel: {
                    margin: 10,
                    textStyle: {
                      fontSize: 12
                    }
                  },
                  splitLine: {
                    lineStyle: {
                      color: newColor
                    },
                    show: false
                  }
                }
              ],
              series: [
                {
                  name: this.nowHistoryItem[i].name,
                  type: "line",
                  smooth: true,
                  symbol: "circle",
                  symbolSize: 5,
                  showSymbol: false,
                  lineStyle: {
                    normal: {
                      width: 1
                    }
                  },
                  areaStyle: {
                    normal: {
                      color: new this.$echarts.graphic.LinearGradient(
                        0,
                        0,
                        0,
                        1,
                        [
                          {
                            offset: 0.6,
                            color: colorRgb(color, 0.3)
                          },
                          {
                            offset: 1,
                            color: colorRgb(color, 0)
                          }
                        ],
                        false
                      ),
                      shadowColor: colorRgb(color, 0.1),
                      shadowBlur: 10
                    }
                  },
                  itemStyle: {
                    normal: {
                      color: color,
                      borderColor: color,
                      borderWidth: 12
                    }
                  },
                  data: this.nowHistoryItem[i].valueDataList,
                  markLine: {
                    symbol: ["none", "arrow"],
                    label: {
                      position: "middle"
                    },
                    data: [
                      {
                        yAxis: threshold,
                        lineStyle: {
                          normal: {
                            color: "red",
                            type: "solid"
                          }
                        }
                      }
                    ]
                  }
                }
              ]
            });
        }
      }
    },
    // 轮询功能
    test () {
      var socket;
      if (typeof WebSocket == "undefined") {
        console.log("您的浏览器不支持WebSocket");
      } else {
        console.log("您的浏览器支持WebSocket");
        //实现化WebSocket对象，指定要连接的服务器地址与端口  建立连接
        //等同于socket = new WebSocket("ws://localhost:8083/checkcentersys/websocket/20");
        socket = new WebSocket(
          "http://192.168.0.46:9003/zhsd/websocket/0".replace("http", "ws")
        );
        //打开事件
        socket.onopen = function () {
          console.log("Socket 已打开");
          //socket.send("这是来自客户端的消息" + location.href + new Date());
        };
        //获得消息事件
        socket.onmessage = function (msg) {
          console.log(msg.data);
          //发现消息进入    开始处理前端触发逻辑
        };
        //关闭事件
        socket.onclose = function () {
          console.log("Socket已关闭");
        };
        //发生了错误事件
        socket.onerror = function () {
          alert("Socket发生了错误");
          //此时可以尝试刷新页面
        };
        //离开页面时，关闭socket
        //jquery1.8中已经被废弃，3.0中已经移除
        // $(window).unload(function(){
        //     socket.close();
        //});
      }
    }
  },
  mounted () {
    // 获取站点数据
    this.axios
      .get(
        this.$store.state.Url4 +
        "station/queryStationBySoId?soId=" +
        this.$store.state.Soid
      )
      .then(data => {
        data = data.data.data;
        this.stationItem = [];
        for (let i in data) {
          this.stationItem.push({
            name: data[i].stnm,
            stcd: data[i].stcd
          });
        }
        if (data[0]) {
          this.form.name = data[0].stnm;
          this.form.stcd = data[0].stcd;
        }
        this.getRealTimeData(this.form.stcd);
        // this.timeRange = [this.times.todayTime, getToday("e", 0)];
        this.timeRange.startTime = this.times.todayTime
        this.timeRange.endTime = getToday("e", 0,"end")
      })
      .catch(err => {
        console.log(err);
      });
  }
};
</script>

<style scoped="scoped">
.container {
  height: 100%;
}
.dialogtitle {
  padding-left: 14px;
  margin: 5px 0;
}
.monitor {
  height: 100%;
  padding: 0 20px;
  background-color: #fff;
  position: relative;
}
.monitor_title {
  padding-top: 5px;
  overflow: hidden;
  line-height: 30px;
  width: 100%;
}
.monitor_title > div {
  float: left;
}
.monitor_logo {
  position: relative;
  top: 6px;
  width: 28%;
}
.monitor_logo > img {
  position: relative;
  top: 4px;
}
.monitor_logo > img:first-child {
  float: left;
}
.monitor_logo > img:last-child {
  float: right;
}
.monitor_query,
.monitor_dictionary {
  margin-left: 10px;
  overflow: hidden;
  position: relative;
  top: 3px;
}
.query_btns {
  display: inline-block;
  padding: 4px 15px;
  border-radius: 5px;
  margin-right: 10px;
  overflow: hidden;
  cursor: pointer;
}
.query {
  background-color: rgba(29, 168, 56, 0.2);
  border: 1px solid rgba(29, 168, 56, 0.667);
  color: #1da838;
}
.print {
  background-color: rgba(19, 152, 226, 0.2);
  border: 1px solid rgba(19, 152, 226, 0.667);
  color: #1398e2;
}
.realTimeData {
  background-color: rgba(184, 134, 11, 0.2);
  border: 1px solid rgba(184, 134, 11, 0.667);
  color: #b8860b;
}
.dictionary {
  background-color: rgba(220, 20, 60, 0.2);
  border: 1px solid rgba(220, 20, 60, 0.667);
  color: #dc143c;
}
.monitor_content {
  height: calc(100% - 69px);
  margin-top: 5px;
  overflow: hidden;
}
.monitor_prev,
.monitor_next {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  cursor: pointer;
}
.monitor_prev {
  left: 442px;
}
.monitor_next {
  right: 0;
  transform: translate(0, -50%) rotate(180deg);
}
.monitor_left {
  float: left;
  height: 100%;
  width: 423px;
  margin-right: 10px;
  box-sizing: border-box;
  border: 2px solid #24893900;
  border-right: 1px solid #28b444;
}
.monitor_left .el-select {
  width: 90%;
  margin-left: 5%;
}
.monitor_box {
  height: calc(100% - 45px);
  box-sizing: border-box;
  padding: 0 5%;
}
.real_title {
  margin: 10px 0;
  overflow: hidden;
}
.real_title > span:first-child {
  font-weight: bold;
  font-size: 16px;
  float: left;
  padding-left: 14px;
}
.real_title > span:last-child {
  float: right;
  font-size: 14px;
  margin-right: 5px;
}
.waterList .real_title > span:first-child,
.waterList .dialogtitle {
  color: #3acee5;
  border-left: 5px solid #3acee5;
}
.weatherList .real_title > span:first-child,
.weatherList .dialogtitle {
  color: #1acfac;
  border-left: 5px solid #1acfac;
}
.airList .real_title > span:first-child,
.airList .dialogtitle {
  color: #fda400;
  border-left: 5px solid #fda400;
}
.soilList .real_title > span:first-child,
.soilList .dialogtitle {
  color: #e15c21;
  border-left: 5px solid #e15c21;
}
.el-checkbox.is-bordered,
.el-checkbox.is-bordered {
  margin: 7px 30px 7px 0 !important;
}
.el-checkbox:last-of-type {
  margin-bottom: 10px;
}
.real_content {
  margin-bottom: 15px;
  overflow: hidden;
}
.real_content > div {
  float: left;
  width: 33.33%;
  height: 100px;
}
.real_box > div {
  width: 80px;
  height: 80px;
  border-radius: 40px;
  overflow: hidden;
  font-size: 8px;
  text-align: center;
  border: 2px dashed;
}
.real_box > div > span:first-child {
  display: inline-block;
  width: 48px;
  height: 50%;
  position: relative;
  top: 18px;
  left: 0;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.real_box > div > span:last-child {
  width: 80px;
  height: 80px;
  border-radius: 0 0 140px 140px;
  display: inline-block;
  text-align: center;
  font-weight: bold;
  font-size: 14px;
  box-sizing: border-box;
  padding: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.monitor_right {
  float: left;
  width: calc(100% - 433px);
  height: 100%;
  overflow: hidden;
}
.monitor_right > div {
  float: left;
  position: relative;
  width: 33%;
  margin-right: 0.3%;
  height: 33%;
  margin-bottom: 0.3%;
}
.monitor_right > div:nth-child(3n) {
  margin-right: 0;
}
.monitor_right > div:nth-child(7),
.monitor_right > div:nth-child(8),
.monitor_right > div:nth-child(9) {
  margin-bottom: 0;
}
.myChart_container span {
  position: absolute;
  top: 10px;
  left: 20px;
  font-size: 16px;
}
.myChart_container img {
  position: absolute;
  top: 13px;
  left: 25px;
}
.myChart_box {
  width: 100%;
  height: 100%;
}
.hide {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  color: white;
}
.hide_container {
  height: 100%;
  position: relative;
}
.hide_box {
  position: absolute;
  width: 60%;
  height: 600px;
  left: 50%;
  top: 50% !important;
  transform: translate(-50%, -50%);
  box-shadow: 1px 1px 50px rgba(0, 0, 0, 0.3);
}
.report_box {
  width: 45%;
  height: auto;
  background: white;
  box-sizing: border-box;
  padding: 20px;
}
.hide_btns {
  text-align: center;
  margin-top: 27px;
}
.hide_title {
  position: relative;
  padding: 0 80px 0 20px;
  height: 42px;
  line-height: 42px;
  border-bottom: 1px solid #eee;
  font-size: 14px;
  color: #333;
  overflow: hidden;
  background-color: #f8f8f8;
  border-radius: 2px 2px 0 0;
}
.hide_title i {
  position: absolute;
  width: 16px;
  height: 16px;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 20px;
  cursor: pointer;
}
.hide_content {
  position: relative;
  padding: 20px 20px 0 20px;
  height: calc(100% - 43px - 20px);
  background: white;
}
.hide_list {
  height: calc(100% - 60px);
}
.list {
  height: 43px;
  line-height: 43px;
  overflow: hidden;
}
.list_title {
  text-align: center;
  font-weight: bold;
}
.list:first-child {
  border-top: 1px solid #dfe6ec;
}
.list > div {
  color: black;
  font-size: 14px;
  padding: 0 15px;
  height: 43px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  float: left;
  box-sizing: border-box;
  border: 1px solid #dfe6ec;
  border-top: none;
  border-right: none;
}
.list > div a {
  cursor: pointer;
  color: #3385ff;
  text-decoration: underline;
}
.list_title > div {
  color: #909399;
  font-size: 16px;
}
.list > div:last-child {
  border-right: 1px solid #dfe6ec;
}
.list > div:nth-child(1),
.list > div:nth-child(2),
.list > div:nth-child(3),
.list > div:nth-child(4) {
  width: calc((100% - 50%) / 4);
}
.list > div:nth-child(5) {
  width: 50%;
}
.el-pagination {
  position: absolute;
  left: 50%;
  bottom: 14px;
  width: 100%;
  transform: translateX(-50%);
  text-align: center;
}
.tips {
  position: absolute;
  right: 20px;
  bottom: 20px;
  color: red;
  font-size: 16px;
}
</style>
<style scoped="scoped">
@media only screen and (max-width: 1582px) {
  .monitor_logo {
    width: 455px;
  }
  .monitor_query {
    width: calc(100% - 465px);
    text-align: center;
  }
  .monitor_dictionary {
    top: 7px;
    width: 100%;
    text-align: center;
  }
  .monitor_content {
    height: calc(100% - 105px);
    margin-top: 0;
  }
  .monitor_left {
    top: 210px;
  }
}
</style>
<style>
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #08961e;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #08961e !important;
}
.el-pagination.is-background .el-pager .active:hover {
  color: white !important;
}
.monitor_box .__view {
  min-height: auto !important;
}
.monitor_box .__rail-is-vertical,
.hide_list .__rail-is-vertical {
  right: -2px !important;
}
.monitor .el-input {
  margin-bottom: 0;
}
.monitor_left .el-select .el-input__inner {
  height: 45px;
  border: solid 1px rgba(40, 180, 68, 0.6);
  background: rgba(40, 180, 68, 0.2);
  color: rgb(40, 180, 68);
  text-align: center;
  font-size: 18px;
  outline: none;
}
.monitor_left .el-select .el-input .el-select__caret {
  color: rgb(40, 180, 68);
  font-size: 25px;
}
.monitor_left .el-select input::-webkit-input-placeholder {
  color: rgb(40, 180, 68);
}
.monitor_left .el-select input::-moz-input-placeholder {
  color: rgb(40, 180, 68);
}
.monitor_left .el-select input::-ms-input-placeholder {
  color: rgb(40, 180, 68);
}
.monitor_left_select .el-scrollbar .el-select-dropdown__list {
  padding: 0;
}
.monitor_left_select .el-scrollbar .el-select-dropdown__item {
  height: 45px;
  line-height: 45px;
  text-align: center;
  background: rgba(40, 180, 68, 0.2);
  color: #28b444;
  transition: 0.2s linear;
}
.monitor_left_select .el-scrollbar .el-select-dropdown__item:hover {
  background: #1e90ff;
  color: white;
}
.transfer_container {
  height: 500px;
  margin-bottom: 20px;
}
.el-transfer,
.el-transfer-panel,
.el-transfer-panel,
.el-transfer-panel__list {
  height: 100%;
}
.el-transfer .el-transfer-panel {
  width: calc(50% - 92px);
}
.el-transfer,
.el-transfer-panel,
.el-transfer-panel,
.el-transfer-panel__list {
  height: 100%;
}
.el-transfer-panel__body {
  height: calc(100% - 40px);
}
.el-transfer__buttons {
  padding: 0 40px;
}
.el-transfer-panel__item.el-checkbox {
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/environmentMonitor/environmentMonitor.vue